import {decodeRestTimeFrame} from "../../../services/TimeSeries/functions/decodeRestTimeFrame";

export default function transformBankDataMap (map = {}, id:string, data:{timeFrames: string[], values:any[]}):TimeSeriesValueNestedMap{
    map[id] = {};
    data.timeFrames.forEach((el, index) => {
        map[id][el] = {timeFrame: decodeRestTimeFrame(el), value: data.values[index]}
    })
    return map;
}
